import type { Organization } from '~~/types/User'

type SchoolSelector = {
  showDialog: boolean
  organizations: Organization[]
  selectedOrganization: Organization | null
  currentActiveOrganization: Organization | null
  updateActive: () => Promise<void>
}

export const useSchoolSelector = () => {
  const { user } = storeToRefs(useAuthStore())
  const { fetchCoreExternalNoJson } = useVgsFetch()

  // Observes changes to the `user` object and updates the state accordingly.
  watch(user, (updated) => {
    const organizations = updated?.schoolOrganizations || []
    const showInitDialog = organizations.length > 1 && !updated?.sessionAttributes.activeOrganization
    state.value.organizations = organizations
    state.value.showDialog = showInitDialog
    state.value.currentActiveOrganization = organizations.find(org => org.number === updated?.sessionAttributes.activeOrganization) || null
  })

  const state = useState<SchoolSelector>('schoolSelector', () => {
    return {
      organizations: [],
      showDialog: false,
      selectedOrganization: null,
      currentActiveOrganization: null,
      updateActive: async () => {
        const organization = state.value.selectedOrganization

        if (!organization) {
          throw new Error('Organization is required')
        }

        const res = await fetchCoreExternalNoJson('/frontend/session/attributes', {
          method: 'PATCH',
          body: JSON.stringify({
            activeOrganization: organization.number,
          }),
        })

        if (!res.ok) {
          throw new Error('Failed to update active organization')
        }

        window.location.reload()
      },
    }
  })

  return state
}
